export default __webpack_public_path__ + "static/media/2097.ba6dc119.png";